import { render, staticRenderFns } from "./SalaryContributionAndTaxes.vue?vue&type=template&id=cb086a0c&scoped=true&"
import script from "./SalaryContributionAndTaxes.vue?vue&type=script&lang=js&"
export * from "./SalaryContributionAndTaxes.vue?vue&type=script&lang=js&"
import style0 from "./SalaryContributionAndTaxes.vue?vue&type=style&index=0&id=cb086a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb086a0c",
  null
  
)

export default component.exports